import { render } from "./EvidenceReviewView.vue?vue&type=template&id=938df30a&scoped=true"
import script from "./EvidenceReviewView.vue?vue&type=script&lang=js"
export * from "./EvidenceReviewView.vue?vue&type=script&lang=js"

import "./EvidenceReviewView.vue?vue&type=style&index=0&id=938df30a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-938df30a"]])

export default __exports__